import { createList } from '../../apis/lists';
// @ts-expect-error Untyped dependency
import exportUnified from './export';
export default ((type, report, listNameOrId) => {
  if (type === 'new') {
    return createList(listNameOrId, '0-1').then(response => {
      const listId = response.listId;
      return exportUnified(report, {
        listId
      });
    });
  } else {
    return exportUnified(report, {
      listId: listNameOrId
    });
  }
});